import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ContentProps } from './types.js';

/** `<Content>` component. */
export const Content = ({ children, className, ...props }: ContentProps): ReactElement => (
  <div className={twMerge('grow px-40', className)} {...props}>
    {children}
  </div>
);
